import { render, staticRenderFns } from "./Enablebatches.vue?vue&type=template&id=6f3454da"
import script from "./Enablebatches.vue?vue&type=script&lang=js"
export * from "./Enablebatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports